import React, { useState } from 'react';
import { Button, Radio, Typography, message } from 'antd';

import { apiPHP } from '../../../../services/api';
import type { SudokuDificuldade } from '../../../../services/admin';
import { apiErrorMessage, fieldLabel, type GeneratorProps } from './types';

// Gerador de sudoku (POST /generate_sudoku) do "+ Novo jogo" (quem anuncia o sucesso é o assistente). O nível do
// sorteio é do gerador; a "Dificuldade" das informações é o rótulo de catálogo.

interface GenerateSudokuResponse {
  id_jogo: number;
}

const LEVELS: { value: SudokuDificuldade; label: string }[] = [
  { value: 'facil', label: 'Fácil' },
  { value: 'medio', label: 'Médio' },
  { value: 'dificil', label: 'Difícil' },
];

export const SudokuGenerator: React.FC<GeneratorProps> = ({ resolveTitle, onCreated }) => {
  const [level, setLevel] = useState<SudokuDificuldade>('medio');
  const [loading, setLoading] = useState(false);

  const generate = async () => {
    const titulo = await resolveTitle();
    if (titulo === null) return;
    setLoading(true);
    try {
      const { data } = await apiPHP.post<GenerateSudokuResponse>('/generate_sudoku', {
        titulo,
        dificuldade: level,
      });
      onCreated(data.id_jogo);
    } catch (e: unknown) {
      message.error(apiErrorMessage(e, 'Falha ao gerar o sudoku.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Typography.Paragraph type="secondary">
        Gera um sudoku 9×9 com solução única — é só escolher o nível do sorteio.
      </Typography.Paragraph>
      <span style={fieldLabel}>Nível do sorteio</span>
      <Radio.Group
        value={level}
        onChange={(e) => setLevel(e.target.value as SudokuDificuldade)}
        options={LEVELS}
        optionType="button"
      />
      <br />
      <Button type="primary" loading={loading} onClick={generate} style={{ marginTop: 12 }}>
        Gerar sudoku
      </Button>
    </div>
  );
};

export default SudokuGenerator;
